

export const  THEMES = {
    DARK_THEME: {
        bg: '#333333',
        text: '#cccccc',
        lines: "#777777",
        tt: {
        bg: '#eeeeee',
        text: '#333333',
        muted: "#666666",
        },
    },
    LIGHT_THEME: {
        bg: '#fefefe',
        text: '#333333',
        lines: "#cccccc",
        tt: {
        bg: '#333333',
        text: '#cccccc',
        muted: "#999999",
        },
    },
}
  